export default __webpack_public_path__ + "static/media/right.0533f57d.svg";